import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";

interface UpdateGroupCardProps {
  numOfInvalidBanks?: number;
}

export const UpdateGroupCard = ({
  numOfInvalidBanks,
}: UpdateGroupCardProps) => {
  return (
    <Card className="center">
      <Card.Body>
        <Card.Title>Groups With Outdated Banks</Card.Title>
        <p className="card-total">{numOfInvalidBanks}</p>
        <div className="card-link">
          <Link className="icon-link" to="/dashboard/company/group">
            Update Groups
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default UpdateGroupCard;
